import React from 'react';

export default function InputPassword({
                                      fieldName,
                                      fieldValue,
                                      prefix,
                                      placeholder,
                                      error,
                                      attr,
                                      inputConstraints,
                                      onChange
                                  }) {

    const handleChange = ({currentTarget: {value}}) => {
        onChange(value);
    }

    return (
        <>
            <input className={`input-field${error ? ' has-error' : ''}`}
                   type="password"
                   id={prefix + fieldName}
                   value={fieldValue}
                   placeholder={placeholder}
                   list={prefix + fieldName}
                   data-is-required={!!inputConstraints?.required}
                   {...attr}
                   onChange={handleChange}/>
        </>
    )
}
